export const PLANET_VERT = /* glsl */ `
varying vec3 vNormalW;
varying vec3 vPosition;
void main() {
  vNormalW = normalize(normalMatrix * normal);
  vPosition = position;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;

export const PLANET_FRAG = /* glsl */ `
precision highp float;
uniform float uTime;
uniform float uSeed;
uniform vec3 uColorA;
uniform vec3 uColorB;
uniform vec3 uAtmosphere;
uniform float uHabitable;
varying vec3 vNormalW;
varying vec3 vPosition;
float hash(vec3 p) {
  p = fract(p * .3183099 + .1);
  p *= 17.0;
  return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
}
float noise(vec3 p) {
  vec3 i = floor(p), f = fract(p);
  f = f * f * (3.0 - 2.0 * f);
  return mix(
    mix(mix(hash(i), hash(i + vec3(1,0,0)), f.x), mix(hash(i + vec3(0,1,0)), hash(i + vec3(1,1,0)), f.x), f.y),
    mix(mix(hash(i + vec3(0,0,1)), hash(i + vec3(1,0,1)), f.x), mix(hash(i + vec3(0,1,1)), hash(i + vec3(1,1,1)), f.x), f.y),
    f.z
  );
}
float fbm(vec3 p) {
  float f = 0.0, a = .5;
  for (int i = 0; i < 5; i++) {
    f += a * noise(p);
    p = p * 2.03 + vec3(1.7, 9.2, 3.4);
    a *= .5;
  }
  return f;
}
void main() {
  vec3 n = normalize(vNormalW);
  vec3 p = normalize(vPosition);
  float continents = fbm(p * 3.2 + uSeed);
  float detail = fbm(p * 15.0 + uSeed * 2.7);
  float ridges = smoothstep(.44, .72, continents + .12 * detail);
  float polar = pow(abs(p.y), 5.0);
  vec3 terrain = mix(uColorA, uColorB, ridges);
  terrain = mix(terrain, uAtmosphere * .82, polar * .24);
  float cityMask = smoothstep(.79, .9, fbm(p * 28.0 + uSeed * 7.0)) * ridges * uHabitable;
  vec3 lightDir = normalize(vec3(.65, .38, .72));
  float ndl = dot(n, lightDir);
  float day = smoothstep(-.18, .38, ndl);
  float diffuse = .08 + .92 * max(ndl, 0.0);
  vec3 color = terrain * (.18 + diffuse);
  color += uAtmosphere * cityMask * (1.0 - day) * 2.8;
  float rim = pow(1.0 - max(dot(n, vec3(0, 0, 1)), 0.0), 3.0);
  color += uAtmosphere * rim * .07;
  float grain = (hash(p * 500.0 + uTime * .002) - .5) * .025;
  color += grain;
  gl_FragColor = vec4(color, 1.0);
}
`;

export const CLOUD_FRAG = /* glsl */ `
precision highp float;
uniform float uTime;
uniform float uSeed;
uniform vec3 uColor;
varying vec3 vNormalW;
varying vec3 vPosition;
float h(vec3 p) { return fract(sin(dot(p, vec3(127.1, 311.7, 74.7))) * 43758.5453); }
float n(vec3 p) {
  vec3 i = floor(p), f = fract(p);
  f = f * f * (3.0 - 2.0 * f);
  return mix(
    mix(mix(h(i), h(i + vec3(1,0,0)), f.x), mix(h(i + vec3(0,1,0)), h(i + vec3(1,1,0)), f.x), f.y),
    mix(mix(h(i + vec3(0,0,1)), h(i + vec3(1,0,1)), f.x), mix(h(i + vec3(0,1,1)), h(i + vec3(1,1,1)), f.x), f.y),
    f.z
  );
}
void main() {
  vec3 p = normalize(vPosition) * 7.0 + vec3(uTime * .012, 0.0, uSeed);
  float cloud = n(p) * .65 + n(p * 2.1) * .35;
  float alpha = smoothstep(.59, .76, cloud) * .32;
  float day = smoothstep(-.2, .35, dot(normalize(vNormalW), normalize(vec3(.65, .38, .72))));
  gl_FragColor = vec4(mix(uColor, vec3(1.0), .45) * (.35 + .65 * day), alpha);
}
`;

export const ATMOS_FRAG = /* glsl */ `
precision highp float;
uniform vec3 uColor;
varying vec3 vNormalW;
varying vec3 vPosition;
void main() {
  vec3 n = normalize(vNormalW);
  float fresnel = pow(1.0 - abs(dot(n, vec3(0, 0, 1))), 2.45);
  float sun = .35 + .65 * max(dot(n, normalize(vec3(.65, .38, .72))), 0.0);
  gl_FragColor = vec4(uColor, fresnel * sun * .58);
}
`;
